import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateCarModalService {

  private selectedCarSubject = new BehaviorSubject<any>(null);
  public selectedCar$ = this.selectedCarSubject.asObservable();

  constructor() { }

  setSelectedCar(car: any): void {
    this.selectedCarSubject.next(car);
  }

  getSelectedCar(): any | null {
    return this.selectedCarSubject.value;
  }

  clearSelectedCar(): void {
    this.selectedCarSubject.next(null);
  }
}

